import { render, staticRenderFns } from "./ProductFamilyNew.vue?vue&type=template&id=74137842&scoped=true&"
import script from "./ProductFamilyNew.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductFamilyNew.vue?vue&type=style&index=0&id=74137842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74137842",
  null
  
)

export default component.exports